import { SIZE_LG, SIZE_MD, SIZE_SM } from '../../config/constants';

export const MODAL_BASE_CLASS = 'modal';

export const MODAL_EVENT_OPENED = 'VUE_MODAL_IS_OPENED';

export const MODAL_SIZES = [
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
];

export const MODAL_TRANSLATIONS = {
  closeButton: 'Close',
};
